import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import dayjs from "dayjs";

const ApiService = {
  getTermsAndConditions: async () => {
    try {
      const response = await axios.get(ApiConstants.getTermsAndConditions);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getPrivacyPolicy: async () => {
    try {
      const response = await axios.get(ApiConstants.getPrivacyPolicy);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getSocialContactInfo: async () => {
    try {
      const response = await axios.get(ApiConstants.getSocialContactInfo);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getHomeData: async () => {
    try {
      const response = await axios.get(ApiConstants.getHomeData);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAboutUsPageContent: async () => {
    try {
      const response = await axios.get(ApiConstants.getAboutUsPageContent);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getCancellationPolicy: async () => {
    try {
      const response = await axios.get(ApiConstants.getCancellationPolicy);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllClasses: async () => {
    try {
      const response = await axios.get(ApiConstants.getAllClasses);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllStates: async () => {
    try {
      const response = await axios.get(ApiConstants.getAllStates);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllDistricts: async (state_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllDistricts + `?state_id=${state_id}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllTalukas: async (district_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllTalukas + `?district_id=${district_id}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAllPincodes: async (taluka_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getAllPincodes + `?taluka_id=${taluka_id}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getFaqcategory: async () => {
    try {
      const response = await axios.get(ApiConstants.getFaqcategory);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getFaqdata: async (selectedCategoryId,limit,offset) => {
    try {
      const response = await axios.get(
        ApiConstants.getFaqdata + (selectedCategoryId ?? "") + `&limit=${limit}` + `&offset=${offset}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  submitContactUsApi: async ({ name, email, subject, message }) => {
    try {
      const response = await axios.post(ApiConstants.submitContactUsApi, {
        name: name,
        email: email,
        subject: subject,
        message: message,
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  submitCoordinatorApi: async ({
    name,
    email,
    mobile,
    dateOfBirth,
    qualification,
    addressLineOne,
    addressLineTwo,
    state,
    district,
    taluka,
    pinCode,
  }) => {
    try {
      const response = await axios.post(ApiConstants.submitCoordinatorApi, {
        name: name,
        email: email,
        mobile: mobile,
        dateOfBirth: dayjs(dateOfBirth).format("YYYY-MM-DD"),
        qualification: qualification,
        addressLineOne: addressLineOne,
        addressLineTwo: addressLineTwo,
        state: state,
        district: district,
        taluka: taluka,
        pinCode: pinCode
      });
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getBlogcategory: async () => {
    try {
      const response = await axios.get(ApiConstants.getBlogcategory);

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getBlogdata: async (selectedCategoryId, offset, limit) => {
    try {
      const response = await axios.get(
        ApiConstants.getBlogdata + (selectedCategoryId ?? "") + `&limit=${limit}` + `&offset=${offset}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getAllAuthers: async () => {
    try {
      const response = await axios.get(ApiConstants.getAllAuthers);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
  getBlogDetailById: async (blog_id) => {
    try {
      const response = await axios.get(
        ApiConstants.getBlogDetailById + (blog_id ?? "")
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },




};


export default ApiService;
